// extracted by mini-css-extract-plugin
module.exports = {"Second":"SecondEu_Second__kARkS"};